import type { HeaderService as HeaderServiceImpl } from '@patsnap-utils/biz';

export const HeaderService = Symbol('HeaderService');

export type HeaderService = HeaderServiceImpl;
